export default {
  PRICING_CONTRACT_TERMS: {
    Title: 'Pricing/Contract Terms',
  },
  ALTERNATIVE_PROVIDER: {
    Title: 'Alternative Provider',
  },
  STAFFING_SCHEDULING_CONSTRAINT: {
    Title: 'Staffing/Scheduling Constraint',
  },
  NO_LONGER_NEEDED: {
    Title: 'No Longer Needed',
  },
  TIMING: {
    Title: 'Timing',
  },
  UNRESPONSIVE: {
    Title: 'Unresponsive',
  },
  OUT_OF_SCOPE: {
    Title: 'Out of Scope',
  },
  INVALID_RECORD: {
    Title: 'Invalid Record',
  },
};
